import { CreateParams } from 'react-admin'
import { APIEntity } from '../entities'
import { callPost, getApiCfg } from './common'
import { SortPayload, PaginationPayload } from 'react-admin'
import { FILTER_SOURCES } from 'services/cfg/filter'

const dataProviderExtension = {
  reorder: (resource: APIEntity, params: CreateParams) => {
    const apiCfg = getApiCfg(resource)
    return callPost(apiCfg, `${apiCfg.endpoint}/reorder`, 'POST', params.data)
  },
}

export type CustomDpExtension = typeof dataProviderExtension

export interface GetListParams {
  pagination: PaginationPayload
  sort: SortPayload
  filter: Record<keyof typeof FILTER_SOURCES, string>
}

export default dataProviderExtension
